<template>
  <v-card class="ml-2 mr-2"  style="height: 100%;">
      <h2 class="text-xs-center">{{$t('dashboard.engagement')}}</h2>
      <div class="ml-2 mr-2">
        <dashboard-engagement-graph class="clickable pt-2 px-2">
        </dashboard-engagement-graph>
      </div>
      <v-progress-circular v-if="loading" id="engagement-graph-spinner" indeterminate :size="50" color="primary"></v-progress-circular>

    <div id="legend" class="clickable">
      <v-layout row>
        <v-flex xs1>
        </v-flex>
        <v-flex xs2 v-for="{label, ratingText, colour} in legend" :key="label"
              class="white--text text-xs-center" @click="legendClick(label)">
            <div class="legend_item":style="{backgroundColor: colour}" slot="activator">{{label}}</div>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import DashboardEngagementGraph from './DashboardEngagementGraph'
import { graphRatingColours, ratingLetter, ratingLabels, ratingMapping } from './ratings'
import { mapState } from 'vuex'
import { GET_LIST_OF_STUDENTS_FOR_ENGAGEMENT } from '../../store/action-types'

export default {
  name: 'dashboard-engagement',
  computed: {
    loading () {
      return this.studentRatingCounts.length === 0
    },
    legend () {
      let legendItems = []
      for (let i = 0; i < 6; i++) {
        const ratingText = this.$t('dashboard.ratings.' + ratingLabels[i])
        legendItems.push({label: ratingLetter[i], ratingText, colour: graphRatingColours[i]})
      }
      return legendItems
    },
    ...mapState({
      studentRatingCounts: state => state.dashboard.studentRatingCounts
    })
  },
  methods: {
    legendClick (label) {
      this.$store.dispatch(GET_LIST_OF_STUDENTS_FOR_ENGAGEMENT, ratingMapping[label])
      this.$router.push({name: 'Students'})
    }
  },
  components: {
    DashboardEngagementGraph
  }
}
</script>

<style scoped>
#engagement-graph-spinner {
  position: absolute;
  left: calc(50% - 20px);
  top: calc(50% - 50px);
}

#legend {
  margin: 4px;
  padding: 8px;
  font-size: 16px;
}
.bottom-line {
  border-bottom: 1px solid lightGray;
}
.clickable {
  cursor: pointer;
}
.legend_item {
  margin-top: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardEngagement.vue